export const ONLINE = 1;
export const REACT_APP_NOME_SISTEMA = 'Sistema de Gestão Total de Abastecimento - SGTA'

// REACT_APP_NOME_SISTEMA=Sistema de Gestão Total de Abastecimento - SGTA